import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { PaymentElement,  Elements } from '@stripe/react-stripe-js';
import {EventRegistrationModal} from "./Event";
import { loadStripe } from '@stripe/stripe-js';
import NotificationContainer from './notification';

const EventDetailPage = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showShareModal, setShowShareModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const stripePromise = loadStripe('pk_live_51S5uZQPcIirE4Ow6UHQQfFxYLQtsfLP45c3MNWk21IImtIWIDinfSDSQ5jgnOV1p8g2b0hbMdZ3rkrOsZGoXTp6200XSaFNZKB');
  const [notifications, setNotifications] = useState([]);
  
  const API_BASE = '/api';

  const { eventId } = useParams();

    const showNotification = (message, type = 'success') => {
        const id = Date.now();
        const notification = { id, message, type };
        setNotifications(prev => [...prev, notification]);
        
        // Auto remove after 5 seconds
        setTimeout(() => {
            setNotifications(prev => prev.filter(n => n.id !== id));
        }, 5000);
    };

    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    };


  // Fetch event details
  useEffect(() => {
    const fetchEventDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/events/${eventId}`);
        if (response.ok) {
          const data = await response.json();
          setEvent(data);
        } else {
          showNotification('Event not found', 'error');
        }
      } catch (error) {
        console.error('Error fetching event:', error);
        showNotification('Error loading event details', 'error');
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventDetails();
    }
  }, [eventId]);

//   useEffect(() => {
//   let counter = 1;
  
//   const intervalId = setInterval(() => {
//     showNotification(`Notification ${counter}`, 'info');
//     counter++;
//   }, 2000); // 2000ms = 2 seconds

//   // Cleanup interval on component unmount
//   return () => clearInterval(intervalId);
// }, []);

  const handleRegisterClick = async (event) =>  {
    const isFree = event.price === "Free" || parseFloat(event.price.replace("£", "")) === 0;
    if (isFree) {
        setModalOpen(true);
        return;
    }
    try {
        const response = await fetch(`${API_BASE}/create-payment-intent-event`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                    amount: parseFloat(event.price.replace('£', '')) * 100,
                    eventId: event.id,
                    event: event.title,
                    attendeeDetails: {}
                }),
        });
        const data = await response.json();
        setClientSecret(data.clientSecret);
        setModalOpen(true);
    } catch (err) {
        console.error('Error creating payment intent:', err);
        showNotification('Failed to initialize payment.', 'error');
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setClientSecret(null);
    setEmail('');
    setName('');
    setCompany('');
  };

  const handleShare = async (platform) => {
    const url = window.location.href;
    const title = event.title;
    const text = `Join me at ${event.title} - ${event.date}`;

    try {
      switch (platform) {
        case 'linkedin':
          window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
          break;
        case 'twitter':
          window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank');
          break;
        case 'email':
          window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + '\n\n' + url)}`;
          break;
        case 'copy':
          await navigator.clipboard.writeText(url);
          showNotification('Link copied to clipboard!', 'success');
          break;
        default:
          break;
      }
      setShowShareModal(false);
    } catch (error) {
      showNotification('Error sharing event', 'error');
    }
  };

  const handleRegister = () => {
    // This would trigger the same registration flow as in EventsPage
    // You can pass this function down or implement the registration logic here
    handleRegisterClick(event);
  };

  if (loading) {
    return (
      <div style={loadingContainerStyles}>
        <div style={loadingSpinnerStyles}></div>
        <p>Loading event details...</p>
      </div>
    );
  }

  if (!event) {
    return (
      <div style={errorContainerStyles}>
        <h2>Event not found</h2>
        <button style={backButtonStyles}>Go Back</button>
      </div>
    );
  }

  // Sample agenda data - in real implementation, this would come from the API
  const sampleAgenda = [
    { time: '9:00 AM', title: 'Registration & Welcome Coffee', speaker: '' },
    { time: '9:30 AM', title: 'Opening Keynote: Saudi-UK Trade Relations', speaker: 'Dr. Sarah Ahmed, Trade Minister' },
    { time: '10:30 AM', title: 'Panel: Investment Opportunities in Vision 2030', speaker: 'Industry Leaders Panel' },
    { time: '12:00 PM', title: 'Networking Lunch', speaker: '' },
    { time: '1:30 PM', title: 'Workshop: Cultural Intelligence in Business', speaker: 'James Robertson, Consultant' },
    { time: '3:00 PM', title: 'Closing Remarks & Next Steps', speaker: 'Network Leadership' }
  ];

  const sampleSpeakers = [
    {
      name: 'Dr. Sarah Ahmed',
      title: 'Trade Minister',
      bio: 'Leading expert in Saudi-UK trade relations with over 15 years of experience in international commerce.',
      image: 'https://images.unsplash.com/photo-1494790108755-2616c6b0e7c?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
    },
    {
      name: 'James Robertson',
      title: 'Cultural Intelligence Consultant',
      bio: 'Specializes in cross-cultural business communication and has facilitated over 200 international partnerships.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
    }
  ];

  return (
    <div style={containerStyles}>
      {/* Back Button */}
      <NotificationContainer removeNotification={removeNotification} notifications={notifications} />

      {/* Hero Section */}
      <div style={heroSectionStyles}>
        <img 
          src={event.image_url || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80'} 
          alt={event.title}
          style={heroImageStyles}
        />
        <div style={heroOverlayStyles}>
          <div style={heroContentStyles}>
            <span style={eventTypeStyles}>{event.event_type}</span>
            <h1 style={eventTitleStyles}>{event.title}</h1>
            <div style={eventMetaStyles}>
              <div style={metaItemStyles}>
                <span style={metaIconStyles}>📅</span>
                <span>{event.date}</span>
              </div>
              <div style={metaItemStyles}>
                <span style={metaIconStyles}>🕐</span>
                <span>{event.time}</span>
              </div>
              <div style={metaItemStyles}>
                <span style={metaIconStyles}>📍</span>
                <span>{event.location}</span>
              </div>
              <div style={metaItemStyles}>
                <span style={metaIconStyles}>💷</span>
                <span style={priceStyles}>{event.price}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={mainContentStyles}>
        <div style={contentGridStyles}>
          {/* Left Column */}
          <div style={leftColumnStyles}>
            {/* Event Description */}
            <section style={sectionStyles}>
              <h2 style={sectionTitleStyles}>About This Event</h2>
              <p style={descriptionStyles}>{event.description}</p>
              
              <div style={highlightBoxStyles}>
                <h3 style={highlightTitleStyles}>What You'll Gain:</h3>
                <ul style={benefitListStyles}>
                  <li>Network with 200+ Saudi and British business leaders</li>
                  <li>Discover new investment opportunities and partnerships</li>
                  <li>Learn about the latest market trends and regulations</li>
                  <li>Access exclusive resources and government contacts</li>
                  <li>Enjoy premium networking opportunities during breaks</li>
                </ul>
              </div>
            </section>

            {/* Agenda */}
            <section style={sectionStyles}>
              <h2 style={sectionTitleStyles}>Event Agenda</h2>
              <div style={agendaContainerStyles}>
                {event.agenda.map((item, index) => (
                  <div key={index} style={agendaItemStyles}>
                    <div style={agendaTimeStyles}>{item.time}</div>
                    <div style={agendaContentStyles}>
                      <h4 style={agendaTitleStyles}>{item.title}</h4>
                      {item.speaker && (
                        <p style={agendaSpeakerStyles}>{item.speaker}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Speakers */}
            <section style={sectionStyles}>
              <h2 style={sectionTitleStyles}>Featured Speakers</h2>
              <div style={speakersGridStyles}>
                {event.speakers.map((speaker, index) => (
                  <div key={index} style={speakerCardStyles}>
                    <img src={speaker.image} alt={speaker.name} style={speakerImageStyles} />
                    <div style={speakerInfoStyles}>
                      <h4 style={speakerNameStyles}>{speaker.name}</h4>
                      <p style={speakerTitleStyles}>{speaker.title}</p>
                      <p style={speakerBioStyles}>{speaker.bio}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* Venue Information */}
            <section style={sectionStyles}>
              <h2 style={sectionTitleStyles}>Venue Details</h2>
              <div style={venueCardStyles}>
                <h3 style={venueNameStyles}>{event.location}</h3>
                {/* <p style={venueAddressStyles}>
                  Canary Wharf, London E14 5AB<br/>
                  United Kingdom
                </p>
                <div style={venueDetailsStyles}>
                  <div style={venueDetailStyles}>
                    <span style={venueIconStyles}>🚇</span>
                    <span>5 min walk from Canary Wharf Station</span>
                  </div>
                  <div style={venueDetailStyles}>
                    <span style={venueIconStyles}>🅿️</span>
                    <span>Parking available on-site</span>
                  </div>
                  <div style={venueDetailStyles}>
                    <span style={venueIconStyles}>♿</span>
                    <span>Wheelchair accessible</span>
                  </div>
                </div> */}
              </div>
            </section>
          </div>

          {/* Right Column - Sticky Registration */}
          <div style={rightColumnStyles}>
            <div style={stickyCardStyles}>
              <h3 style={cardTitleStyles}>Register for this Event</h3>
              <div style={priceBadgeStyles}>{event.price}</div>
              
              <div style={eventSummaryStyles}>
                <div style={summaryItemStyles}>
                  <span style={summaryLabelStyles}>Date:</span>
                  <span>{event.date}</span>
                </div>
                <div style={summaryItemStyles}>
                  <span style={summaryLabelStyles}>Time:</span>
                  <span>{event.time}</span>
                </div>
                <div style={summaryItemStyles}>
                  <span style={summaryLabelStyles}>Location:</span>
                  <span>{event.location}</span>
                </div>
                <div style={summaryItemStyles}>
                  <span style={summaryLabelStyles}>Type:</span>
                  <span>{event.event_type}</span>
                </div>
              </div>

              {event.has_happened ? (
                <div style={pastEventNoticeStyles}>
                  This event has already taken place
                </div>
              ) : (
                <>
                  <button onClick={handleRegister} style={registerButtonStyles}>
                    Register Now
                  </button>
                  
                  <div style={urgencyNoticeStyles}>
                    <span style={urgencyIconStyles}>⚡</span>
                    Limited seats available - Register today!
                  </div>
                </>
              )}

              <div style={shareSectionStyles}>
                <button 
                  onClick={() => setShowShareModal(true)} 
                  style={shareButtonStyles}
                >
                  📤 Share Event
                </button>
              </div>

              {/* Contact Info */}
              <div style={contactSectionStyles}>
                <h4 style={contactTitleStyles}>Questions?</h4>
                <p style={contactInfoStyles}>
                  📧 events@saudibritishnetwork.com<br/>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Share Modal */}
      {showShareModal && (
        <div style={modalOverlayStyles} onClick={() => setShowShareModal(false)}>
          <div style={modalContentStyles} onClick={(e) => e.stopPropagation()}>
            <div style={modalHeaderStyles}>
              <h3>Share this Event</h3>
              <button 
                onClick={() => setShowShareModal(false)} 
                style={modalCloseStyles}
              >
                ×
              </button>
            </div>
            <div style={shareOptionsStyles}>
              <button onClick={() => handleShare('linkedin')} style={shareOptionStyles}>
                <span style={shareIconStyles}>💼</span>
                LinkedIn
              </button>
              <button onClick={() => handleShare('twitter')} style={shareOptionStyles}>
                <span style={shareIconStyles}>🐦</span>
                Twitter
              </button>
              <button onClick={() => handleShare('email')} style={shareOptionStyles}>
                <span style={shareIconStyles}>📧</span>
                Email
              </button>
              <button onClick={() => handleShare('copy')} style={shareOptionStyles}>
                <span style={shareIconStyles}>📋</span>
                Copy Link
              </button>
            </div>
          </div>
        </div>
      )}

      { modalOpen && (
        event.price === "Free" || parseFloat(event.price.replace("£", "")) === 0 ? (
                        <Elements stripe={stripePromise} >
                                <EventRegistrationModal stripe={stripePromise}
                                                selectedEvent={event}
                                                email={email}
                                                name={name}
                                                company={company}
                                                onClose={handleModalClose}
                                                onSuccess={handleModalClose}
                                                setEmail={setEmail}
                                                setName={setName}
                                                setCompany={setCompany}
                                                showNotification={showNotification}
                                                setModalOpen={setModalOpen}
                                                paymentSection={<div></div>}
                                />
                        </Elements>
         ) : (clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <EventRegistrationModal 
                            selectedEvent={event}
                            email={email}
                            name={name}
                            company={company}
                            onClose={handleModalClose}
                            onSuccess={handleModalClose}
                            setEmail={setEmail}
                            setName={setName}
                            setCompany={setCompany}
                            showNotification={showNotification}
                            setModalOpen={setModalOpen}
                            paymentSection={
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600' }}>
                                        Card Details
                                    </label>
                                    <div style={{ padding: '1rem', border: '2px solid #e1e1e1', borderRadius: '10px', marginBottom: '1rem' }}>
                                        <PaymentElement />
                                    </div>
                                </div>
                            }
                    />
            </Elements> 
         )
        )
      )}
    </div>
  );
};

// Styles
const loadingContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px',
  color: '#666'
};

const loadingSpinnerStyles = {
  width: '40px',
  height: '40px',
  border: '4px solid #f3f3f3',
  borderTop: '4px solid #006C35',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: '1rem'
};

const errorContainerStyles = {
  textAlign: 'center',
  padding: '4rem 2rem',
  color: '#666'
};

const containerStyles = {
  fontFamily: 'system-ui, sans-serif',
  backgroundColor: '#f8f9fa',
  minHeight: '100vh',

  overflow: 'hidden', // This clips fixed elements
  transform: 'translateX(...)', // Creates new stacking context
  position: 'relative'
};

const backButtonStyles = {
  background: 'none',
  border: '2px solid #006C35',
  color: '#006C35',
  padding: '0.8rem 1.5rem',
  borderRadius: '25px',
  fontSize: '1rem',
  fontWeight: '600',
  cursor: 'pointer',
  margin: '2rem',
  transition: 'all 0.3s ease'
};

const heroSectionStyles = {
  position: 'relative',
  height: '60vh',
  overflow: 'hidden'
};

const heroImageStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};

const heroOverlayStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(135deg, rgba(0, 108, 53, 0.8), rgba(196, 30, 58, 0.8))',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const heroContentStyles = {
  textAlign: 'center',
  color: 'white',
  maxWidth: '800px',
  padding: '0 2rem'
};

const eventTypeStyles = {
  background: 'rgba(255, 255, 255, 0.2)',
  color: 'white',
  padding: '0.5rem 1rem',
  borderRadius: '20px',
  fontSize: '0.9rem',
  fontWeight: '600',
  display: 'inline-block',
  marginBottom: '1rem'
};

const eventTitleStyles = {
  fontSize: '3.5rem',
  fontWeight: '700',
  marginBottom: '2rem',
  lineHeight: '1.2'
};

const eventMetaStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '2rem'
};

const metaItemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '1.1rem'
};

const metaIconStyles = {
  fontSize: '1.2rem'
};

const priceStyles = {
  fontWeight: '700',
  fontSize: '1.3rem'
};

const mainContentStyles = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '4rem 2rem'
};

const contentGridStyles = {
  display: 'grid',
  gridTemplateColumns: '2fr 1fr',
  gap: '4rem'
};

const leftColumnStyles = {};

const rightColumnStyles = {};

const sectionStyles = {
  marginBottom: '4rem'
};

const sectionTitleStyles = {
  fontSize: '2rem',
  fontWeight: '700',
  color: '#333',
  marginBottom: '2rem',
  borderBottom: '3px solid #006C35',
  paddingBottom: '0.5rem'
};

const descriptionStyles = {
  fontSize: '1.1rem',
  lineHeight: '1.7',
  color: '#666',
  marginBottom: '2rem'
};

const highlightBoxStyles = {
  background: '#e8f5e8',
  border: '1px solid #c8e6c9',
  borderRadius: '15px',
  padding: '2rem',
  marginTop: '2rem'
};

const highlightTitleStyles = {
  color: '#2e7d32',
  marginBottom: '1rem'
};

const benefitListStyles = {
  listStyle: 'none',
  padding: 0
};

const agendaContainerStyles = {
  background: 'white',
  borderRadius: '15px',
  padding: '2rem',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
};

const agendaItemStyles = {
  display: 'flex',
  gap: '2rem',
  paddingBottom: '1.5rem',
  marginBottom: '1.5rem',
  borderBottom: '1px solid #e9ecef'
};

const agendaTimeStyles = {
  minWidth: '100px',
  fontWeight: '600',
  color: '#006C35'
};

const agendaContentStyles = {
  flex: 1
};

const agendaTitleStyles = {
  margin: '0 0 0.5rem 0',
  color: '#333'
};

const agendaSpeakerStyles = {
  margin: 0,
  color: '#666',
  fontSize: '0.9rem'
};

const speakersGridStyles = {
  display: 'grid',
  gap: '2rem'
};

const speakerCardStyles = {
  display: 'flex',
  gap: '1.5rem',
  background: 'white',
  padding: '2rem',
  borderRadius: '15px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
};

const speakerImageStyles = {
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  objectFit: 'cover'
};

const speakerInfoStyles = {
  flex: 1
};

const speakerNameStyles = {
  margin: '0 0 0.5rem 0',
  color: '#333'
};

const speakerTitleStyles = {
  margin: '0 0 1rem 0',
  color: '#006C35',
  fontWeight: '600'
};

const speakerBioStyles = {
  margin: 0,
  color: '#666',
  lineHeight: '1.5'
};

const venueCardStyles = {
  background: 'white',
  padding: '2rem',
  borderRadius: '15px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
};

const venueNameStyles = {
  margin: '0 0 1rem 0',
  color: '#333'
};

const venueAddressStyles = {
  color: '#666',
  marginBottom: '2rem',
  lineHeight: '1.5'
};

const venueDetailsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.8rem'
};

const venueDetailStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.8rem'
};

const venueIconStyles = {
  fontSize: '1.2rem',
  minWidth: '24px'
};

const stickyCardStyles = {
  background: 'white',
  padding: '2rem',
  borderRadius: '15px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  position: 'sticky',
  top: '2rem'
};

const cardTitleStyles = {
  margin: '0 0 1.5rem 0',
  color: '#333',
  textAlign: 'center'
};

const priceBadgeStyles = {
  background: '#006C35',
  color: 'white',
  padding: '1rem',
  borderRadius: '10px',
  textAlign: 'center',
  fontSize: '1.5rem',
  fontWeight: '700',
  marginBottom: '2rem'
};

const eventSummaryStyles = {
  marginBottom: '2rem'
};

const summaryItemStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '0.8rem',
  marginBottom: '0.8rem',
  borderBottom: '1px solid #e9ecef'
};

const summaryLabelStyles = {
  fontWeight: '600',
  color: '#333'
};

const registerButtonStyles = {
  background: '#006C35',
  color: 'white',
  border: 'none',
  padding: '1rem 2rem',
  borderRadius: '50px',
  fontSize: '1.1rem',
  fontWeight: '600',
  cursor: 'pointer',
  width: '100%',
  marginBottom: '1rem',
  transition: 'all 0.3s ease'
};

const pastEventNoticeStyles = {
  background: '#f5f5f5',
  color: '#666',
  padding: '1rem',
  borderRadius: '10px',
  textAlign: 'center',
  marginBottom: '1rem'
};

const urgencyNoticeStyles = {
  background: '#fff3cd',
  color: '#856404',
  padding: '0.8rem',
  borderRadius: '8px',
  fontSize: '0.9rem',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  marginBottom: '1.5rem'
};

const urgencyIconStyles = {
  fontSize: '1rem'
};

const shareSectionStyles = {
  marginBottom: '2rem'
};

const shareButtonStyles = {
  background: '#f8f9fa',
  border: '2px solid #e9ecef',
  color: '#666',
  padding: '0.8rem',
  borderRadius: '10px',
  width: '100%',
  cursor: 'pointer',
  fontSize: '1rem'
};

const contactSectionStyles = {
  borderTop: '1px solid #e9ecef',
  paddingTop: '1.5rem'
};

const contactTitleStyles = {
  margin: '0 0 1rem 0',
  color: '#333'
};

const contactInfoStyles = {
  color: '#666',
  lineHeight: '1.6',
  margin: 0
};

const modalOverlayStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000
};

const modalContentStyles = {
  background: 'white',
  borderRadius: '15px',
  padding: '2rem',
  maxWidth: '400px',
  width: '90%'
};

const modalHeaderStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '2rem'
};

const modalCloseStyles = {
  background: 'none',
  border: 'none',
  fontSize: '2rem',
  cursor: 'pointer',
  color: '#666'
};

const shareOptionsStyles = {
  display: 'grid',
  gap: '1rem'
};

const shareOptionStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  background: '#f8f9fa',
  border: '2px solid #e9ecef',
  borderRadius: '10px',
  cursor: 'pointer',
  fontSize: '1rem',
  transition: 'all 0.3s ease'
};

const shareIconStyles = {
  fontSize: '1.2rem'
};

export default EventDetailPage;